<script setup lang="ts">
import { ref, watch } from "vue";
import { RouterView, useRoute } from "vue-router";

defineProps<{ wallMode: boolean }>();

const route = useRoute();
const scrollContainer = ref<HTMLElement | null>(null);

watch(
  () => route.path,
  () => {
    // Each destination starts at its heading, independent of the prior page.
    scrollContainer.value?.scrollTo({ top: 0 });
  },
  { flush: "post" },
);
</script>

<template>
  <main class="relative z-10 min-h-0 flex-1 overflow-hidden">
    <div ref="scrollContainer" class="h-full overflow-y-auto">
      <div
        :class="[
          'mx-auto',
          wallMode
            ? 'min-h-full px-4 pb-3.5'
            : 'max-w-[1760px] px-3 pb-5 sm:px-4 md:px-5 xl:px-6',
        ]"
      >
        <RouterView />
      </div>
    </div>
  </main>
</template>
